import Vue from 'vue'
import configs from '@/config'
import store from '@/store'
import SystemConnection, { CONNECTION_STATUS } from '@/utils/system/SystemConnection'

let resource = null
// Because version 1, we don't have result ID yet due to descoped features.
// SO I will use this const to fake the result ID
const TEMP_CATEGORISE_ID = '-1'
const actions = {
  getMyQuizAnswers: {
    method: 'GET',
    url: `${configs.baseUrl}/api/answers/quiz?presentationId={presentationId}&audienceId={audienceId}`,
  },
  createWordCloudAnswerV2: {
    method: 'POST',
    url: `${configs.baseUrlLiveApi}/api/stream/answers/wordcloud`,
  },
  createWordCloudAnswerV1: {
    method: 'POST',
    url: `${configs.baseUrl}/api/slide-option/audience-create-wordcloud`,
  },
  createPollAnswerV2: {
    method: 'POST',
    url: `${configs.baseUrlLiveApi}/api/stream/answers/poll`,
  },
  createPollAnswerV1: {
    method: 'POST',
    url: `${configs.baseUrl}/api/answer/create`,
  },
  createScaleAnswerV2: {
    method: 'POST',
    url: `${configs.baseUrlLiveApi}/api/stream/answers/scale`,
  },
  createScaleAnswerV1: {
    method: 'POST',
    url: `${configs.baseUrl}/api/answer/create`,
  },
  createQuizAnswer: {
    method: 'POST',
    url: `${configs.baseUrl}/api/answer/create`,
  },
  createCategoriseAnswer: {
    method: 'POST',
    url: `${configs.baseUrlLiveApi}/api/stream/answers/categories`,
  },
}

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}

const getMyQuizAnswers = async ({ presentationId, audienceId }, params) => {
  const res = await resource.getMyQuizAnswers({ presentationId, audienceId }, params)

  return res.body
}

const createWordCloudAnswer = async (payload) => {
  try {
    if (store.getters['featureToggles/canUseWordCloudEmqx']) {
      const res = await resource.createWordCloudAnswerV2(payload)
      return res.body
    }
    const res = await resource.createWordCloudAnswerV1(payload)
    return res.body
  } catch (error) {
    SystemConnection.detectGeneralConnection(CONNECTION_STATUS.UNSTABLE)
    return { body: { error: error.message } }
  }
}

const createPollAnswer = async (payload) => {
  try {
    if (store.getters['featureToggles/canUsePollEmqx']) {
      const res = await resource.createPollAnswerV2(payload)
      return res.body
    }
    const res = await resource.createPollAnswerV1(payload)
    return res.body
  } catch (error) {
    SystemConnection.detectGeneralConnection(CONNECTION_STATUS.UNSTABLE)
    return { body: { error: error.message } }
  }
}

const createScaleAnswer = async (payload) => {
  try {
    if (store.getters['featureToggles/canUseScaleEmqx']) {
      const res = await resource.createScaleAnswerV2(payload)
      return res.body
    }
    const res = await resource.createScaleAnswerV1(payload)
    return res.body
  } catch (error) {
    SystemConnection.detectGeneralConnection(CONNECTION_STATUS.UNSTABLE)
    return { body: { error: error.message } }
  }
}

const createQuizAnswer = async (payload) => {
  try {
    const res = await resource.createQuizAnswer(payload)
    return res.body
  } catch (error) {
    SystemConnection.detectGeneralConnection(CONNECTION_STATUS.UNSTABLE)
    return { body: { error: error.message } }
  }
}

const createCategoriseAnswer = async (payload) => {
  const res = await resource.createCategoriseAnswer(payload)
  res.body.id = TEMP_CATEGORISE_ID
  return res.body
}

export default {
  initResource,
  getMyQuizAnswers,
  createWordCloudAnswer,
  createScaleAnswer,
  createPollAnswer,
  createCategoriseAnswer,
  createQuizAnswer,
}
